import { LoadingBar } from "quasar";

LoadingBar.setDefaults({
  // return a Boolean which has the meaning of "does this URL should trigger LoadingBar?"
  hijackFilter(url) {
    return url.includes("zammit") || url.includes("localhost");
  },
});
